export default {
  productTradeMark: {
    TrademarkCode: '品牌编号',
    TrademarkName: '品牌名称',
    AddTrademark: '新增商品品牌',
    EditTrademark: '修改商品品牌',
    PleaseEnterTrademarkName: '请输入商品名称',
    PleaseEnterTrademarkCode: '请输入商品编号',
    PleaseEnterCorrectTrademarkCode: '请输入正确的商品编号',
    PleaseEnterCorrectTrademarkName: '请输入正确的商品名称'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/pmc/productTradeMark.js